import { Typography, type TypographyProps } from '../typography/Typography';
import { IfNodeRenders } from '../util/IfNodeRenders';

export const EmptyMessageDescription = ({ children, ...props }: TypographyProps<'div'>) => (
  <IfNodeRenders node={children}>
    <Typography color='text.secondary' textAlign='center' variant='body2' {...props}>
      {children}
    </Typography>
  </IfNodeRenders>
);
